import { render } from "./HealthCheckLogTable.vue?vue&type=template&id=84faf648&scoped=true"
import script from "./HealthCheckLogTable.vue?vue&type=script&lang=js"
export * from "./HealthCheckLogTable.vue?vue&type=script&lang=js"

import "./HealthCheckLogTable.vue?vue&type=style&index=0&id=84faf648&scoped=true&lang=css"

import exportComponent from "/Users/chordarts/pasti/dev10/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84faf648"]])

export default __exports__